import totalAgentTypes from '../totalAgentTypes';

const agentData = {
  type: 'agent',
  stateValue: 'agent',
  title: 'Agents',
  dashboardPath: '/agents/dashboard',
  abTestPath: '/abTest',
  abTestOverviewPath: '/abTest/overview',
  overviewPath: '/agents/overview',
  createPath: '/agents/create',
  editPath: '/agents/edit',
  draftPath: '/agents/draft',
  draftDashboardPath: '/agents-draft',
  draft: { label: 'Agent', value: 'campaign' },
  allAgentTypes: totalAgentTypes,
  steps: [
    {
      title: 'Goal',
    },
    {
      title: 'Define',
    },
    {
      title: 'Design',
    },
    {
      title: 'Publish',
    },
  ],
  aiAgentSteps: [
    {
      title: 'Goal',
    },
    {
      title: 'Define',
    },
    {
      title: 'Publish',
    },
  ],
  qualificationSteps: [
    {
      title: 'Goal',
    },
    {
      title: 'Define',
    },
    {
      title: 'Design',
    },
    {
      title: 'Publish',
    },
  ],
  domainTypes: [
    {
      name: 'Full domain',
      value: 'fullDomain',
      color: 'blue',
    },
    {
      name: 'Single page',
      value: 'singlePage',
      color: 'green',
    },
    {
      name: 'Section of domain',
      value: 'sectionOfDomain',
      color: 'orange',
    },
    {
      name: 'Regex',
      value: 'regexSectionOfDomain',
      color: 'red',
    },
  ],
};

export default agentData;
